import PropTypes from "prop-types"
import React, { Fragment, useState } from "react"

//i18n
import { withTranslation } from "react-i18next"
import SuperAdminDashboard from "./SuperAdminDashboard"
import NationalAlgonAdminDashboard from "./NationalAlgonAdminDashboard"
import NationalAlgonCoordinatorDashboard from "./NationalAlgonCoordinatorDashboard"
import StateAdminDashboard from "./StateAdminDashboard"
import StateAlgonChairmanDashboard from "./StateAlgonChairmanDashboard"
import LgaFocalPersonDashboard from "./LgaFocalPersonDashboard"
import LgaChairmanDashboard from "./LgaChairmanDashboard"
import { getUserRole } from "constants/roles"

const Dashboard = props => {
  const [userRole] = useState(getUserRole())

  //meta title
  document.title = "Dashboard | UNICEF - e-Recruitment Portal"

  return (
    <Fragment>
      {userRole === "SUPER_ADMIN" && <SuperAdminDashboard />}

      {/* New ALGON roles */}
      {userRole === "NATIONAL_ALGON_ADMIN" && <NationalAlgonAdminDashboard />}
      {userRole === "NATIONAL_ALGON_COORDINATOR" && <NationalAlgonCoordinatorDashboard />}
      {userRole === "STATE_ADMIN" && <StateAdminDashboard />}
      {userRole === "STATE_ALGON_CHAIRMAN" && <StateAlgonChairmanDashboard />}
      {userRole === "LGA_FOCAL_PERSON" && <LgaFocalPersonDashboard />}
      {userRole === "LGA_CHAIRMAN" && <LgaChairmanDashboard />}
    </Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
